
<h5>Agenda</h5>

<ct-model [configuration]="configuration"></ct-model>

